import * as actionTypes from '../actions/actionTypes';

export default (state = [], action) => {
    switch (action.type) {
        case actionTypes.SHIPPING_OPTIONS:
            return [...action.payload];
        default:
            return state;
    }
};
